<template lang="pug">
  lei-modal(
    @close="closeModal",
    size='lg'
    :title="relationship.exception ? 'Reporting Exception' : 'Relationship Data'"
  )
    title-section(v-if="!relationship.exception")
      .names-block
        label.parent-name {{relationship.parent.id}} {{relationshipParentName}}
        label.child-name &rdsh;{{relationship.child.id}} {{relationshipChildName}}
    collapsed-data-sections(for-modal :sections="relationshipTables")
</template>
<script>
import record from '@/constants/tooltips/record'
import { mapGetters, mapMutations, mapState, } from 'vuex'
import { TOGGLE_RELATIONSHIP_MODAL, } from '@/store/modules/record/mutations-types'
import TitleSection from '../record-details/TitleSection'
import LeiModal from '../lei-components/LeiModal'
import ChallengeControlSection from '../challenge-components/ChallengeControlSection'
import CollapsedDataSections from '@/components/record-details/CollapsedDataSections'

export default {
  components: {
    CollapsedDataSections,
    ChallengeControlSection,
    LeiModal,
    TitleSection,
  },
  data () {
    return {
      tooltips: record,
    }
  },
  computed: {
    relationshipTables () {
      if (!this.relationship.exception) {
        return [
          {
            title: 'Relationship details',
            data: this.relationshipDetails,
            property: 'showRelationshipDetails',
          },
          // {
          //   title: 'Dates',
          //   data: this.relationshipDates,
          //   property: 'showRelationshipDates',
          // },
          {
            title: 'Registration details',
            data: this.relationshipRegistrationDetails,
            property: 'showRelationshipRegistrationData',
          },
        ]
      } else {
        return [
          {
            title: 'Exception details',
            data: this.relationshipException,
            property: 'showRelationshipException',
          },
        ]
      }
    },

    ...mapState('record', [ 'relationship', ]),
    ...mapGetters('record', [
      'relationshipParentName',
      'relationshipChildName',
      'relationshipDates',
      'relationshipDetails',
      'relationshipRegistrationDetails',
      'relationshipException',
    ]),
  },
  methods: {
    closeModal () {
      this.toggleModal({ show: false, })
    },

    ...mapMutations('record', {
      toggleModal: TOGGLE_RELATIONSHIP_MODAL,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .names-block
    display flex
    flex-direction column
    line-height 1.25
    padding-right 15px

    .child-name
      color $default-color-middle
      font-weight 600

    .parent-name
      font-weight 700
      color $default-color-bold-1
      font-size 150%

</style>



// WEBPACK FOOTER //
// src/components/modals/RelationshipModal.vue